import { render, staticRenderFns } from "./FindRoommatesCard.vue?vue&type=template&id=89e66b0e&"
import script from "./FindRoommatesCard.vue?vue&type=script&lang=js&"
export * from "./FindRoommatesCard.vue?vue&type=script&lang=js&"
import style0 from "./FindRoommatesCard.vue?vue&type=style&index=0&id=89e66b0e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports